import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { ImageIcon, LinkIcon } from '@phosphor-icons/react'

import AddVariablesButton from '../AddVariablesButton/AddVariablesButton'
import { fontOptions, headerOptions, sizeOptions } from './constants'

const QuillToolbar = forwardRef(
  ({ toolbarId, config = {}, onAddLink, onAddImage, onAddVariable, availableVariables, availableSections }, ref) => {
    const { t } = useTranslation()

    return (
      <div id={toolbarId} role="toolbar" className="ql-toolbar ql-snow" ref={ref}>
        {config.header && (
          <span className="ql-formats">
            <select className="ql-header" defaultValue="">
              {headerOptions.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {t(opt.labelKey)}
                </option>
              ))}
            </select>
          </span>
        )}
        {config.font && (
          <span className="ql-formats">
            <select className="ql-font" defaultValue="">
              {fontOptions.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </span>
        )}
        {config.size && (
          <span className="ql-formats">
            <select className="ql-size" defaultValue="">
              {sizeOptions.map(opt => (
                <option key={opt.value} value={opt.value}>
                  {opt.label}
                </option>
              ))}
            </select>
          </span>
        )}
        {(config.bold || config.italic || config.color || config.background) && (
          <span className="ql-formats">
            {config.bold && (
              <Tooltip title={t('Negrita')}>
                <span>
                  <button className="ql-bold" />
                </span>
              </Tooltip>
            )}
            {config.italic && (
              <Tooltip title={t('Cursiva')}>
                <span>
                  <button className="ql-italic" />
                </span>
              </Tooltip>
            )}
            {config.color && <select className="ql-color" />}
            {config.background && <select className="ql-background" />}
          </span>
        )}
        {(config.listBullet || config.listOrdered || config.align) && (
          <span className="ql-formats">
            {config.listBullet && (
              <Tooltip title={t('Lista')}>
                <span>
                  <button className="ql-list" value="bullet" />
                </span>
              </Tooltip>
            )}
            {config.listOrdered && (
              <Tooltip title={t('Lista ordenada')}>
                <span>
                  <button className="ql-list" value="ordered" />
                </span>
              </Tooltip>
            )}
            {config.align && (
              <Tooltip title={t('Alineación')}>
                <select className="ql-align" />
              </Tooltip>
            )}
          </span>
        )}
        {(config.addLink || config.addImage || config.addVariable) && (
          <span className="ql-formats">
            {config.addLink && (
              <Tooltip title={t('Añadir enlace')}>
                <span>
                  <button onClick={onAddLink}>
                    <LinkIcon />
                  </button>
                </span>
              </Tooltip>
            )}
            {config.addImage && (
              <Tooltip title={t('Añadir imagen')}>
                <span>
                  <button onClick={onAddImage}>
                    <ImageIcon />
                  </button>
                </span>
              </Tooltip>
            )}
            {config.addVariable && (
              <Tooltip title={t('Añadir variable')}>
                <AddVariablesButton
                  onAddVariable={onAddVariable}
                  withLabel={false}
                  availableVariables={availableVariables}
                  availableSections={availableSections}
                />
              </Tooltip>
            )}
          </span>
        )}
      </div>
    )
  }
)

QuillToolbar.displayName = 'QuillToolbar'

export default QuillToolbar
